import type { VoucherI18nInput } from "@/lib/gql/__generated__/graphql";

import type { MarketingVoucherI18nFormModel } from "../../../../../type";

type Props = {
	viewModel: MarketingVoucherI18nFormModel["ViewModel"];
};

export const viewModelToInputConverter = ({ viewModel }: Props): VoucherI18nInput => {
	const input: VoucherI18nInput = {
		hotelID: viewModel.hotelID,
		voucherID: viewModel.voucherID,

		lang: viewModel.lang,

		name: viewModel.name.value,
		description: viewModel.description.value,
	} satisfies VoucherI18nInput;

	return input;
};
